<template>
  <div>
    <div class="field control">
      <div class="field">
        <label class="label">{{$t("first_name").tTitle()}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            v-validate="'required|alpha_spaces|max:32'"
            :class="{'input': true, 'is-danger': errors.has('firstName') }"
            name="firstName"
            type="text"
            :data-vv-as="$t('first_name').tTitle()"
            :placeholder="$t('first_name').tTitle()"
            v-model="payData.firstName"
          />
          <span
            v-show="errors.has('firstName')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('firstName') }}</span>
          <span class="icon is-small is-left">
            <i class="fa fa-user"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <label class="label">{{$t("last_name").tTitle()}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            v-validate="'required|alpha_spaces|max:32'"
            :class="{'input': true, 'is-danger': errors.has('lastName') }"
            name="lastName"
            type="text"
            :data-vv-as="$t('last_name').tTitle()"
            :placeholder="$t('last_name').tTitle()"
            v-model="payData.lastName"
          />
          <span
            v-show="errors.has('lastName')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('lastName') }}</span>
          <span class="icon is-small is-left">
            <i class="fa fa-user"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <bank-list
          v-validate="'required'"
          :data-vv-as="$t('bank_name').tTitle()"
          :banks="this.data.banks"
          v-model="payData.bank"
          id="bank_option"
          name="bank_option"
        ></bank-list>
        <span
          v-show="errors.has('bank_option')"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          class="help is-danger"
        >{{ errors.first('bank_option') }}</span>
      </div>
      <div class="field">
        <label class="label">{{$t("account_no").tTitle()}}</label>
        <p class="control has-icons-left has-icons-right">
          <input
            v-validate="'required|numeric|max:18'"
            :class="{'input': true, 'is-danger': errors.has('accountNumber') }"
            name="accountNumber"
            type="text"
            :data-vv-as="$t('account_no').tTitle()"
            :placeholder="$t('account_no').tTitle()"
            v-model="payData.accountNumber"
          />
          <span
            v-show="errors.has('accountNumber')"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            class="help is-danger"
          >{{ errors.first('accountNumber') }}</span>
          <span class="icon is-small is-left">
            <i class="fa fa-hashtag"></i>
          </span>
        </p>
      </div>

      <div class="field">
        <h5 class="title">{{$t("please_enter_amount_withdraw")}}</h5>

        <div class="field has-addons">
          <p class="control">
            <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
          </p>
          <p class="control">
            <input
              v-validate="'required|currency|min_value:' + minWdValue"
              :class="{'input': true, 'is-danger': errors.has('amount') }"
              name="amount"
              type="text"
              :data-vv-as="$t('amount')"
              :placeholder="$t('amount').tTitle()"
              v-model="payData.amount"
            />
            <span
              v-show="errors.has('amount')"
              class="help is-danger"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
            >{{ errors.first('amount') }}</span>
          </p>
          <p class="control">
            <a
              class="button is-success"
              @click="withdraw"
            >
              <span class="icon is-small">
                <i
                  class="fa fa-check"
                  :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
                ></i>
              </span>
              <span>{{$t("withdraw").tTitle()}}</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '../../../../../config'
import BankList from './Banklist.vue'

export default {
  components: {
    BankList,
  },
  props: ['data'],
  data() {
    return {
      minWdValue: 50,
      currencySymbols: config.currencies,
      payData: {
        firstName: '',
        lastName: '',
        accountType: '',
        bank: '',
        accountNumber: '',
        amount: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  watch: {},
  methods: {
    withdraw() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return false
        }

        this.$bus.$emit('requestPRWithdraw', this.payData)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// MX.vue?3a1535ae